function Header() {
  return (
    <h1>Toll Management Application</h1>
  )
}

export default Header